// extracted by mini-css-extract-plugin
export default {"menuItems":"MoreOptionsMenu_menuItems__MOus0","menuItem":"MoreOptionsMenu_menuItem__78U9J"};